module.exports = __webpack_public_path__ + "img/8.5bf88bd2.jpg";